// HTTP service
// wraps api calls with common options (headers, json parsing, etc.)

// global event bus
import Vue from 'vue'
const bus = new Vue()

const API_URL = process.env.API_URL

export default {
  baseUrl: API_URL,
  bus: bus,
  get (url, headers, payload, silent) {
    return this.fetchWrapper('GET', url, headers, payload, silent)
  },
  post (url, headers, payload, silent) {
    return this.fetchWrapper('POST', url, headers, payload, silent)
  },
  patch (url, headers, payload, silent) {
    return this.fetchWrapper('PATCH', url, headers, payload, silent)
  },
  delete (url, headers, silent) {
    return this.fetchWrapper('DELETE', url, headers, undefined, silent)
  },
  fetchWrapper (method, url, headers, payload, silent) {
    const opts = {
      method,
      url: buildUrl(url),
      headers: buildHeaders(headers),
      payload,
      silent
    }
    bus.$emit('outbound-request', opts)
    return makeRequestPromise.bind(this)(opts)
  }
}

function buildUrl (url) {
  return API_URL + url
}

function buildHeaders (extraHeaders) {
  const baseHeaders = {
    Accept: 'application/json'
  }
  const result = {}
  Object.assign(result, baseHeaders, extraHeaders)
  return result
}

function checkStatus (response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    const error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

function queryParams (params) {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&')
}

function makeRequestPromise (opts) {
  const options = {
    method: opts.method,
    headers: opts.headers
  }
  if (options.method === 'POST' || options.method === 'PATCH') {
    options.body = JSON.stringify(opts.payload)
    options.headers['Content-Type'] = 'application/json'
  }
  let url
  if ((options.method === 'GET' || options.method === 'DELETE') &&
      typeof opts.payload !== 'undefined') {
    url = `${opts.url}?${queryParams(opts.payload)}`
  } else {
    url = opts.url
  }
  return fetch(url, options)
    .then(checkStatus)
    .then((response) => {
      this.bus.$emit('request-success', response)
      return response.json().catch(() => {
        return {}
      })
    }).catch((error) => {
      this.bus.$emit('request-error', error)
      throw error
    })
}

export {
  buildUrl
}



// WEBPACK FOOTER //
// ./src/services/http/index.js